export default (permissaoUsuario, acao, pagina) => {
    if (!pagina.acoes.includes(acao)){
        return false;
    }
    if (permissaoUsuario.set(pagina.aplicacao,pagina.funcionalidade, pagina.tela, acao)){
        return true
    }
    return false
}